import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class TrendingSearchUseCase extends BaseUseCase {
    constructor(Repo) {
        super();
        this.Repo = Repo;
    }
    async fetchResult(req) {
        return await this.Repo.getTrending(req);
    }
}
export default TrendingSearchUseCase;
